import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[(!_vm.isValidClientId)?_c(VAlert,{attrs:{"type":"warning"}},[_vm._v(_vm._s(_vm.$t('general.invalidUrl')))]):_c('SubBubbleAgreementsContainer',{attrs:{"client-id":_vm.clientIdFormatted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }